import React from 'react'
import "../footer/Footer.scss"
import { FaFacebookF } from "react-icons/fa6";
import { RiInstagramFill } from "react-icons/ri";
import { FaYoutube } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";

function Footer() {
  const copyrightdate = new Date().getFullYear()
  return (
    <>
    <div className="footer parent">
        <div className="footer-cont cont">
            <div className="footer-left">
                <p>Copyright©{copyrightdate}.All Rights Reserved</p>
            </div>
            <div className="footer-right">
                <a href="https://www.facebook.com/SambhajiPatilBJP"  target='_blank' rel="noreferrer"><span><FaFacebookF /></span></a>
                <a href="https://www.instagram.com/sambhajipatil77/-"  target='_blank' rel="noreferrer"><span><RiInstagramFill /></span></a>
                <a href="https://www.youtube.com/SambhajiPatilNilangekar77"  target='_blank' rel="noreferrer"><span><FaYoutube /></span></a>
                <a href="https://x.com/i/flow/login?redirect_after_login=%2Fsambhajipatil77" target='_blank' rel="noreferrer"><span><BsTwitterX /></span></a>
            </div>
        </div>

    </div>

    
    
    
    
    </>
  )
}

export default Footer

